import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import MobileFooterButton from '@/components/mobile-footer-button'
import { Button } from '@/components/button'
import { CompanyListings } from '@/features/CompanyManagement'
import { select } from '@/store'

const ManageListings = ({ history, match }) => {
  const { t } = useTranslation()

  const userId = match?.params?.userId
  const users = useSelector(state => state?.companyManagement?.users)
  const user = users?.[userId]

  const buildings = useSelector(state =>
    select.companyManagement.buildings(state, {
      userId
    })
  )

  const handleRowClick = listingId => {
    history.push(`/manage/listings/${listingId}/`)
  }

  const getPageTitle = () => {
    if (user) {
      const nameEndsWithS = user.first_name.match(/.*(s)$/i)
      return `${user.first_name}${nameEndsWithS ? `'` : `'s`} ${t('common.listings', 'Listings')}`
    }
    return ''
  }

  const EditUserButton = () => (
    <Button to={`/manage/users/${userId}/edit/`} theme="secondary" size="small">
      {t('l.manage_users.list.manage_users_listings_edit_user.button', 'Edit user')}
    </Button>
  )

  const MobileEditUserButton = () => (
    <MobileFooterButton to={`/manage/users/${userId}/edit/`} displayBelow="desktop">
      {t('l.manage_users.list.manage_users_listings_edit_user.button', 'Edit user')}
    </MobileFooterButton>
  )

  return (
    <CompanyListings
      pageTitle={getPageTitle()}
      buildings={buildings}
      onRowClick={handleRowClick}
      buttonComponent={EditUserButton}
      mobileButtonComponent={MobileEditUserButton}
    />
  )
}

export default memo(ManageListings)
